export default __webpack_public_path__ + "static/media/pdflayout2.1eaaa332.png";